import { SrtBaseFieldConfig } from '../types';

const hasRowFieldValue = (value: any) => String(value ?? '').trim() !== '';

export const isSrtFieldVisible = (
    field: SrtBaseFieldConfig,
    row: Record<string, any>
) =>
    (!field.visibleWhen ||
        String(row?.[field.visibleWhen.fieldName] ?? '') === String(field.visibleWhen.value)) &&
    !(field.hiddenWhenFieldHasValue && hasRowFieldValue(row?.[field.hiddenWhenFieldHasValue]));

export const isSrtFieldDisabled = (
    field: SrtBaseFieldConfig,
    row: Record<string, any>
) =>
    Boolean(field.disabledUntilField && !row?.[field.disabledUntilField]) ||
    Boolean(
        field.disabledWhenFieldHasValue &&
            hasRowFieldValue(row?.[field.disabledWhenFieldHasValue])
    );

export const resolveSrtField = (
    field: SrtBaseFieldConfig,
    row: Record<string, any>
): SrtBaseFieldConfig => {
    let resolvedField = field;

    if (resolvedField.exactLengthByFieldValue) {
        const { fieldName, lengths } = resolvedField.exactLengthByFieldValue;
        const exactLength = lengths[String(row?.[fieldName] ?? '')];
        const isRequired = resolvedField.required || Boolean(exactLength);
        const staticValidations = (resolvedField.validations || []).filter(
            (validation) => validation.name !== 'required' && validation.name !== 'fixedLength'
        );

        resolvedField = {
            ...resolvedField,
            maxLength: exactLength || Math.max(...Object.values(lengths)),
            required: isRequired,
            validations: isRequired
                ? [
                      ...staticValidations,
                      { name: 'required' },
                      ...(exactLength ? [{ name: 'fixedLength' as const, param: exactLength }] : [])
                  ]
                : staticValidations
        };
    }

    if (resolvedField.requiredWhenFieldEmpty || resolvedField.requiredOnlyIfFieldHasValue) {
        const isReferencedFieldEmpty = resolvedField.requiredWhenFieldEmpty
            ? !hasRowFieldValue(row?.[resolvedField.requiredWhenFieldEmpty])
            : true;
        const isGateSatisfied = resolvedField.requiredOnlyIfFieldHasValue
            ? hasRowFieldValue(row?.[resolvedField.requiredOnlyIfFieldHasValue])
            : true;
        const shouldBeRequired = isReferencedFieldEmpty && isGateSatisfied;
        const staticValidations = (resolvedField.validations || []).filter(
            (validation) => validation.name !== 'required'
        );

        resolvedField = {
            ...resolvedField,
            required: shouldBeRequired,
            validations: shouldBeRequired
                ? [...staticValidations, { name: 'required' }]
                : staticValidations
        };
    }

    if (
        resolvedField.fullWidthWhenFieldHasValue &&
        hasRowFieldValue(row?.[resolvedField.fullWidthWhenFieldHasValue])
    ) {
        resolvedField = { ...resolvedField, gridColumns: 12 };
    }

    return resolvedField;
};
